import { Link } from "react-router-dom";

export default function MutualFriends({ mutualFriends }) {
  if (!mutualFriends || mutualFriends.count === 0) {
    return null;
  }

  const displayedFriends = mutualFriends.friends.slice(0, 6);
  const remainingCount = mutualFriends.count - displayedFriends.length;

  return (
    <div className="profile_card">
      <div className="profile_card_header">
        Mutual Friends
        <div className="profile_header_link">
          {mutualFriends.count} mutual friend{mutualFriends.count > 1 ? "s" : ""}
        </div>
      </div>
      <div className="mutual_friends_grid">
        {displayedFriends.map((friend) => (
          <Link
            to={`/profile/${friend.username}`}
            className="mutual_friend_item"
            key={friend._id}
          >
            <img src={friend.picture} alt="" />
            <span className="mutual_friend_name">
              {friend.first_name} {friend.last_name}
            </span>
          </Link>
        ))}
      </div>
      {remainingCount > 0 && (
        <div className="mutual_friends_more">
          +{remainingCount} more mutual friend{remainingCount > 1 ? "s" : ""}
        </div>
      )}
    </div>
  );
}
